import { motion } from 'framer-motion';
import { Globe, MapPin } from 'lucide-react';

export const StickyBadges = () => {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col gap-3">
      {/* Deutschlandweit Badge */}
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 1 }}
        className="group"
      >
        <div className="flex items-center bg-gradient-to-r from-tiktok-surface to-tiktok-elevated rounded-l-2xl border border-r-0 border-white/10 overflow-hidden cursor-pointer hover:border-tiktok-cyan/50 transition-all">
          <div className="flex items-center gap-3 px-4 py-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-tiktok-cyan/30 to-tiktok-cyan/10 flex items-center justify-center">
              <MapPin className="w-5 h-5 text-tiktok-cyan" />
            </div>
            <div className="pr-2">
              <p className="text-white font-bold text-sm">Deutschlandweit</p>
              <p className="text-gray-400 text-xs">Kostenlose Abholung</p>
            </div>
          </div>
          <div className="w-1.5 h-full bg-gradient-to-b from-tiktok-cyan to-tiktok-cyan/50" />
        </div>
      </motion.div>

      {/* Europaweit Badge */}
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 1.2 }}
        className="group"
      >
        <div className="flex items-center bg-gradient-to-r from-tiktok-surface to-tiktok-elevated rounded-l-2xl border border-r-0 border-white/10 overflow-hidden cursor-pointer hover:border-tiktok-pink/50 transition-all">
          <div className="flex items-center gap-3 px-4 py-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-tiktok-pink/30 to-tiktok-pink/10 flex items-center justify-center">
              <Globe className="w-5 h-5 text-tiktok-pink" />
            </div>
            <div className="pr-2">
              <p className="text-white font-bold text-sm">Europaweit</p>
              <p className="text-gray-400 text-xs">Ankauf & Export</p>
            </div>
          </div>
          <div className="w-1.5 h-full bg-gradient-to-b from-tiktok-pink to-tiktok-pink/50" />
        </div>
      </motion.div>
    </div>
  );
};

export default StickyBadges;
